import { render, staticRenderFns } from "./GenericRuta.vue?vue&type=template&id=2f210fc6"
import script from "./GenericRuta.vue?vue&type=script&lang=js"
export * from "./GenericRuta.vue?vue&type=script&lang=js"
import style0 from "./GenericRuta.vue?vue&type=style&index=0&id=2f210fc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports